// Per-site onboarding readiness: the request-intent editor (6th record) on top,
// the render trigger/preview below. RBAC resolved once and passed down.

import { useIsPlatformAdmin } from "../auth/useIsPlatformAdmin";
import { OnboardingRequestEditor } from "./OnboardingRequestEditor";
import { RenderPanel } from "./RenderPanel";

export function SiteOnboardingReadiness({ siteSlug }: { siteSlug: string }) {
  const canWrite = useIsPlatformAdmin();
  return (
    <div style={{ display: "grid", gap: 28 }}>
      <section>
        <h3 style={{ margin: "0 0 12px", fontSize: "0.95rem" }}>Onboarding request intent</h3>
        <OnboardingRequestEditor siteSlug={siteSlug} canWrite={canWrite} />
      </section>
      <section>
        <h3 style={{ margin: "0 0 12px", fontSize: "0.95rem" }}>Render request.yml</h3>
        <RenderPanel siteSlug={siteSlug} canWrite={canWrite} />
      </section>
    </div>
  );
}
